export const BoldSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.01875 15.9375C3.07499 15.9375 2.3 16.7062 2.3 17.6562C2.3 18.6063 3.07499 19.375 4.01875 19.375H12.1437C15.2063 19.375 17.7 16.8813 17.7 13.8187C17.7 12.3875 17.1563 11.0375 16.1625 10C17.1563 8.96252 17.7 7.61249 17.7 6.16875C17.7 3.11249 15.2063 0.625 12.1437 0.625H4.01875C3.07499 0.625 2.3 1.39374 2.3 2.34375C2.3 3.29376 3.07499 4.0625 4.01875 4.0625H4.63749V15.9375H4.01875ZM12.1437 15.9375H8.08125V11.7188H12.15C12.7063 11.7188 13.2375 11.9375 13.6438 12.3375C14.0437 12.7375 14.2625 13.2625 14.2625 13.8187C14.2625 14.9875 13.3125 15.9375 12.1437 15.9375ZM13.6438 7.66251C13.2438 8.05626 12.7125 8.27499 12.1438 8.28125H8.08125V4.0625H12.1438C13.3125 4.0625 14.2625 5.00626 14.2625 6.16875C14.2625 6.73126 14.0437 7.2625 13.6438 7.66251Z"
      fill="currentColor"
    />
  </svg>
);
